import { useNavigate } from "react-router-dom";
import { Box, Typography, Paper, Button } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

export default function Forms() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 3,
        marginLeft: "100px",
      }}
    >
      <Paper
        elevation={0}
        sx={{
          padding: 3,
          backgroundColor: "white",
          borderRadius: 2,
          mb: 3,
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <Typography variant="h4" component="h1" sx={{ fontWeight: 600, color: "#333" }}>
            Formulários
          </Typography>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={() => navigate("/form-builder")}
            sx={{
              backgroundColor: "#FF006F",
              "&:hover": { backgroundColor: "#d6005a" },
            }}
          >
            Novo Formulário
          </Button>
        </Box>
        <Typography variant="body1" sx={{ color: "#666" }}>
          Crie e gerencie formulários de tarefas para seus processos
        </Typography>
      </Paper>
    </Box>
  );
}
